const dataAttributes = document.currentScript.dataset;
const adsInArticle = dataAttributes.articleAds;

/**
* Avoid multiple function execution on some repetitive actions
* like window resize or multiple clicks.
*/
function debounce (fn, delay) {
    let timer = null;

    return function () {
        const context = this;
        const args = arguments;

        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
}

/**
 * Returns boolean in case if passed element is in viewport or not.
 * Source: https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/
 * When 'partiallyVisible = true' (default) then the function returns 'true'
 * when even the smallest part of the element is visible,
 * and if 'partiallyVisible = false' then the entire element must be in the viewport
 * for the function to return 'true'.
*/
function isInViewport(el, partiallyVisible = true) {
    const {
        top, left, bottom, right
    } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;

    return partiallyVisible
        ? ((top > 0 && top < innerHeight)
            || (bottom > 0 && bottom < innerHeight))
        && ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
}

/**
 * Source for 'makeUniqueId' method: https://stackoverflow.com/a/1349426/20210910
 */
function makeUniqueId(length) {
    let result = '';
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let counter = 0;
    while (counter < length) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
        counter += 1;
    }
    return result;
}

/**
 * Call the Google function to display the banner.
 */
function googletagCmdPush(resultSlot, mappingPairs, slotId) {
    window.googletag.cmd.push(function () {
        const slot = window.googletag.defineSlot('' + resultSlot.id, resultSlot.slot_sizes, slotId)
            .defineSizeMapping(window[mappingPairs] || [])
            .setTargeting(resultSlot.targeting[0], resultSlot.targeting[1])
            .setCollapseEmptyDiv(resultSlot.collapse, resultSlot.collapse)
            .addService(window.googletag.pubads());

        window.googletag.display(slotId);
        if (window.disableInitalLoad && !window.adpushupIsEnabled) googletag.pubads().refresh([slot]);
    });
}

/**
 * If the slot is visible on the screen,
 * then the banner is displayed immediately,
 * and if not, then the scroll checks
 * whether it is in the viewport
 * and when it is, the banner is displayed.
 * 
 * There is no control option via admin for now - add it in the future?
 */
function showBanner(slot, dfpElement, mappingPairs, uniqueId) {
    if (isInViewport(dfpElement)) {
        googletagCmdPush(slot, mappingPairs, uniqueId);
    } else {
        const controller = new AbortController();
        window.addEventListener('scroll', debounce(() => {
            if (isInViewport(dfpElement)) {
                googletagCmdPush(slot, mappingPairs, uniqueId);
                controller.abort();
            }
        }, 10), { passive: true, signal: controller.signal });
    }
}

/**
 * Prepare the slot for placing the banner.
 */
window.prepareSlots = () => {
    for (var i = dfpDisplayTagSlots.length - 1; i >= 0; i--) {
        let divId = dfpDisplayTagSlots[i];
        const idForMapping = divId.split('div').join('').split('mAutostart_').join('');

        const slotData = dfp_all_slots.filter(e => {
            const elem = e.customId;

            return elem === idForMapping && !e.outOfPage;
        });
        
        const bannerWrapper = document.getElementById(divId);

        if (bannerWrapper && slotData.length) {
            const uniqueId = makeUniqueId(10);
            divId = `${divId}_${uniqueId}`;
            bannerWrapper.setAttribute('id', divId);

            let mappingPairs = '';

            if (window.mappings.length) {
                mappingPairs = window.mappings.filter(e => e.includes(idForMapping)).join('').split('__')[0];
            }

            const dfpElement = document.getElementById(divId);

            showBanner(slotData[0], dfpElement, mappingPairs, divId);

            dfpDisplayTagSlots.splice(i, 1);
        }
    }
};

/**
 * Finds a place to insert the banner slot.
 */
window.placeForDfp = (feed) => {
    let repeatAfter = 4;
    let articleElements = [];

    if (feed && window.platform !== 'mobile') {
        repeatAfter = 3;
        const elements = [];
        let elementToProcess = [];

        const part1 = document.querySelectorAll('.js_placeForDfp article.card');
        if (part1.length) elements.push(...part1);

        const part2 = document.querySelectorAll('.js_extraNewsContent article.card');
        if (part2.length) elements.push(...part2);

        const elementsWithoutDataCardUsed = elements.filter(e => { if (e.dataset) e.dataset.elementProcessed !== 'true' });
        const numOfElementsToDelete = elements.length % repeatAfter;

        if (numOfElementsToDelete > 0) {
            elementToProcess = elementsWithoutDataCardUsed.slice(0, -numOfElementsToDelete);
            articleElements.push(...elementToProcess);
        } else {
            articleElements.push(...elementsWithoutDataCardUsed);
        }
    } else {
        const content = document.querySelector('.js_articleContent');
        const elements = content ? content.childNodes : null;
        if (elements && elements.length) articleElements = [...elements].filter(e => e.nodeName !== '#text');
    }

    const elementsToProcess = [...articleElements].filter(e => { if (e.dataset) e.dataset.elementProcessed !== 'true' });

    elementsToProcess.forEach((articleElement, index) => {
        if (((index + 1) % repeatAfter) === 0) {
            const slotId = window.platform === 'mobile' ? 'mAutostart_Rec2' : 'divLeaderboard2';

            const externalSlotDiv = document.createElement('div');
            const classToAdd = window.platform === 'mobile' ? 'gr-12 hidden visible_mobile' : 'dfp_banner dfp_banner--Leaderboard';
            externalSlotDiv.setAttribute('class', classToAdd);

            const internalSlotDiv = document.createElement('div');
            internalSlotDiv.setAttribute('id', slotId);

            externalSlotDiv.appendChild(internalSlotDiv);

            articleElement.insertAdjacentElement('afterend', externalSlotDiv);

            dfpDisplayTagSlots.push(slotId);
        }

        if (articleElement.dataset) articleElement.dataset.elementProcessed = true;
    });

    window.prepareSlots();
};

/**
 * Initiates the display of the banner in the gallery.
 */
window.initGalleryDfp = () => {
    const activeSlide = document.querySelector('.rsSlide.rsActiveSlide');
    const activeBanner = activeSlide ? activeSlide.querySelector('.dfp_banner') : null;

    if (activeBanner) window.prepareSlots();
};

/**
 * If the AdPushup script is enabled and doesn't exist yet,
 * its code is placed at the top of the page.
 */
function insertAdpushupScript() {
    const adpushupOnPage = document.getElementById('adpushup');

    if (window.adpushupIsEnabled && !adpushupOnPage) {
        const adpushupScript = document.createElement('script');
        adpushupScript.src = '//cdn.adpushup.com/46706/adpushup.js';
        adpushupScript.crossOrigin = 'anonymous';
        adpushupScript.type = 'text/javascript';
        adpushupScript.async = true;
        adpushupScript.id = 'adpushup';

        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(adpushupScript);

        window.adpushup = window.adpushup || {que:[]};
    }
}

/**
 * Initiates slot preparation and banner display
 * only after slots are loaded from admin,
 * and 'dfp_all_slots' array is prepared.
 */
function attemptDfpInit () {
    if (dfpDataReady) {
        window.prepareSlots();
        insertAdpushupScript();
    } else {
        setTimeout(() => {
            attemptDfpInit();
        }, 300);
    }
}

if (adsInArticle === undefined || adsInArticle === 'True') {
    attemptDfpInit();

    const isMobile = window.innerWidth < 1024;

    /**
     * Reload the site in order to display banners
     * adjusted to the screen width.
     */
    window.addEventListener('resize', debounce(() => {
        if (window.innerWidth < 1024 !== isMobile) {
            window.location.reload();
        }
    }, 200));
}
